import React, { useEffect } from "react";
import { observer, inject } from "mobx-react";
import cx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";
import BrandCardHeader from "@mui-treasury/components/cardHeader/brand";
import CardContent from "@material-ui/core/CardContent";
import { useOverShadowStyles } from "@mui-treasury/styles/shadow/over";
import FormConstructor from "../../organisms/FormConstructor";
import MarkDown from "../../molecules/display/MarkDown";
import Form from "../../organisms/Form";
import { isField } from "../../utils/fieldTypes";
import signInInputs from "../../utils/formFields/signInInputs";
import handleNavigation from "../../utils/handleNavigation";

const useStyles = makeStyles(() => ({
  root: {
    margin: "auto",
    borderRadius: 12
  },
  media: {
    borderRadius: 6
  },
  marginBottom20: {
    marginBottom: 20
  }
}));

const signInForm = new FormConstructor(
  { fields: signInInputs.filter(field => isField(field.type)) },
  { name: "signInForm" }
);

const LoginForm = inject("store")(
  observer(
    ({
      store,
      store: {
        forms,
        ui: { formSubmitting }
      },
      content
    }) => {
      const styles = useStyles();
      const shadowStyles = useOverShadowStyles({ inactive: true });

      useEffect(() => {
        if (!forms?.signInForm) {
          store.setForm("signInForm", signInForm);
        }
      });

      return (
        <Card className={cx(styles.root, shadowStyles.root)}>
          <BrandCardHeader extra={"Login"} />
          <CardContent>
            {content && (
              <div className={styles.marginBottom20}>
                <MarkDown source={content} variants={{ p: "body1" }} />
              </div>
            )}
            <Form
              fields={signInInputs}
              form={signInForm}
              buttonProps={{
                color: "primary",
                fullWidth: true,
                variant: "contained"
              }}
            />
          </CardContent>
          <CardContent>
            <MarkDown
              className="mb-3"
              source={`Can't remember your password?
              You can try [resetting your password](/change-password).`}
              variants={{ p: "body1" }}
            />
            <Button
              disabled={formSubmitting}
              onClick={() => handleNavigation("/change-password")}
              type="button"
              variant="outlined"
              fullWidth
              color="primary"
            >
              Reset your password
            </Button>
          </CardContent>
        </Card>
      );
    }
  )
);

export default LoginForm;
